import useGetDebounceValue from '@vindr/utils/hooks/useGetDebounceValue';
import { Input, Row } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { useCallback, useEffect, useState } from 'react';

type InputFilter = Omit<Parameters<typeof Input>[0], 'title'> & {
  value?: string | string[];
  onChange: (value: string) => void;
  title?: string | boolean;
  delay?: number;
  width?: HTMLElement['style']['width'];
  autoSearch?: boolean;
  wrapperClassName?: string;
  className?: string;
  onClear?: () => void;
};

const InputFilter = ({
  value,
  onChange,
  onPressEnter,
  placeholder,
  title,
  delay = 500,
  width = 200,
  className,
  autoSearch = true,
  wrapperClassName,
  onClear,
  ...props
}: InputFilter) => {
  const [search, setSearch] = useState(value);
  const debouncedOnChange = useGetDebounceValue(search, delay);

  const handleOnChange = useCallback((val) => {
    setSearch(val);
  }, []);

  // Change searchState when value prop change
  useEffect(() => {
    setSearch(value);
  }, [value]);

  useEffect(() => {
    onChange(debouncedOnChange);
  }, [`${debouncedOnChange}`]);

  return (
    <div className={wrapperClassName} style={{ width, maxWidth: '100%' }}>
      {title && <Row className="filter-title pb-1 pt-[6px]">{title}</Row>}
      <Input
        size="small"
        value={search}
        className={className}
        placeholder={placeholder}
        onChange={(e) => {
          const val = e.target.value;

          if (autoSearch) {
            handleOnChange(val);
          } else {
            onChange(val);
          }

          if (isEmpty(val)) onClear?.();
        }}
        onPressEnter={(e) => onPressEnter?.(e.target.value)}
        {...props}
      />
    </div>
  );
};

export default InputFilter;
